export class PlanService {
    plans = [
        {
            id: 3354,
            name: 'Basic',
            price: 59.99,
            newPrice: 59.99,
            discountPrice: 47.99,
            includedTexts: '1,000',
            addTexts: '$0.058',
            addTextsNew: '$0.058',
            dashboards: 1,
           
            link: 'basic',
            includedFeatures: ['2-Way Texting', 'Mass Texting', 'Payments', 'SMS Chat', 'Message Templates', 'Unlimited Users', 'Unlimited Contacts', '10DLC Verified Sending'],
            optionalFeatures: [
                {
                    id: 19,
                    name: 'Reviews',
                    nameHint: ' (up to 25 dashboards)',
                    cost: 50,
                    description: 'Connect your Google and Facebook business profiles to earn, reply to, and track online reviews. Priced per 25 dashboards.'
                },
                /*
                {
                    id: 16,
                    name: 'Call Forwarding',
                    nameHint: ' (up to 25 dashboards)',
                    cost: 25,
                    description: 'Callers are seamlessly forwarded to a voice-enabled phone number you provide. Priced per account, up to 25 dashboards.'
                },
                */
                {
                    id: 4,
                    name: 'API Access',
                    cost: 50,
                    description: 'Our CTO said we can’t build every feature 😞. But you can build your own solutions with our programmable APIs and webhooks 😁.'
                },
                /*
                {
                    id: 3,
                    name: 'SMS Chat',
                    cost: 20,
                    description: 'Lead generation’s superhero sidekick. This widget lets customers text you from your website. Drive leads and improve service.'
                },
                */
                {
                    id: 6,
                    name: 'Scheduled Messages',
                    cost: 20,
                    description: 'Schedule your messages to send once at a specific time or automatically on a repeating basis.'
                },
                {
                    id: 17,
                    name: 'Location Requests',
                    cost: 15,
                    description: 'Request a contact’s location, and have them send you a pin with their exact address.'
                },
                {
                    id: 7,
                    name: 'Keywords',
                    cost: 15,
                    description: 'A word that contacts text to opt in or receive info. Use to create and manage subscribers.'
                },
                {
                    id: 1,
                    name: 'Custom Merge',
                    cost: 15,
                    description: 'Create group messages with information that relates directly to each contact receiving the message. All you need is a CSV file with names, numbers, and information.'
                },
                {
                    id: 2,
                    name: 'Chrome Extension',
                    cost: 15,
                    description: 'We put our dashboard in a Chrome extension so you can use Text Request from any web page! Side effects include: happier work days.'
                }
                

            ],
            priorPlan: '',
            linkedInConversionId: 9948729
        },
        {
            id: 3350,
            name: 'Starter',
            price: 145,
            newPrice: 145,
            discountPrice: 116,
            includedTexts: '2,500',
            addTexts: '$0.058',
            addTextsNew: '$0.058',
            dashboards: 2,
            mostPopular: true,
            link: 'starter',
            includedFeatures: ['All Basic Features', 'Scheduled Messages', 'Location Requests', 'Unlimited Keywords', 'Chrome Extension', '3rd Party Integrations'],
            optionalFeatures: [
                {
                    id: 19,
                    name: 'Reviews',
                    cost: 50,
                    description: 'Connect your Google and Facebook business profiles to earn, reply to, and track online reviews.'
                },
                /*
                {
                    id: 16,
                    name: 'Call Forwarding',
                    nameHint: ' (up to 25 dashboards)',
                    cost: 25,
                    description: 'Callers are seamlessly forwarded to a voice-enabled phone number you provide. Priced per account, up to 25 dashboards.'
                },
                */
                {
                    id: 1,
                    name: 'Custom Merge',
                    cost: 15,
                    description: 'Create group messages with information that relates directly to each contact receiving the message. All you need is a CSV file with names, numbers, and information.'
                },
                {
                    id: 4,
                    name: 'API Access',
                    cost: 50,
                    description: 'Our CTO said we can’t build every feature 😞. But you can build your own solutions with our programmable APIs and webhooks 😁.'
                }

            ],
            priorPlan: 'Basic',
            linkedInConversionId: 9948737

        },
        {
            id: 3347,
            name: 'Corporate',
            price: 295,
            newPrice: 295,
            discountPrice: 236,
            includedTexts: '6,500',
            addTexts: '$0.049',
            addTextsNew: '$0.049',
            dashboards: 5,
            discount: true,
            link: 'corporate',
            includedFeatures: ['All Starter Features', 'Custom Merge', '5 Dashboards (Text Lines)'],
            optionalFeatures: [
                {
                    id: 19,
                    name: 'Reviews',
                    cost: 50,
                    description: 'Connect your Google and Facebook business profiles to earn, reply to, and track online reviews.'
                },
                /*
                {
                    id: 16,
                    name: 'Call Forwarding',
                    nameHint: ' (up to 25 dashboards)',
                    cost: 25,
                    description: 'Callers are seamlessly forwarded to a voice-enabled phone number you provide. Priced per account, up to 25 dashboards.'
                },
                */
                {
                    id: 4,
                    name: 'API Access',
                    cost: 50,
                    description: 'Our CTO said we can’t build every feature 😞. But you can build your own solutions with our programmable APIs and webhooks 😁.'
                }

            ],
            priorPlan: 'Starter',
            linkedInConversionId: 9948745
        },
        {
            id: 3003,
            name: 'Enterprise',
            price: 575,
            newPrice: 575,
            includedTexts: '20,000',
            addTexts: '$0.032',
            addTextsNew: '$0.032',
            dashboards: 10,
            link: 'enterprise',
            includedFeatures: ['All Corporate Features', 'API Access', '10 Dashboards (Text Lines)'],
            optionalFeatures: [
                {
                    id: 19,
                    name: 'Reviews',
                    cost: 50,
                    description: 'Connect your Google and Facebook business profiles to earn, reply to, and track online reviews.'
                },
                /*
                {
                    id: 16,
                    name: 'Call Forwarding',
                    nameHint: ' (up to 25 dashboards)',
                    cost: 25,
                    description: 'Callers are seamlessly forwarded to a voice-enabled phone number you provide. Priced per account, up to 25 dashboards.'
                },
                */
            ],
            priorPlan: 'Corporate',
            linkedInConversionId: 9948753
        },
        {
            id: 3004,
            name: 'High Volume Tier 1',
            price: 890,
            newPrice: 890,
            includedTexts: '50,000',
            addTexts: '$0.019',
            addTextsNew: '$0.019',
            dashboards: 10,
            link: 'highvolume1',
            includedFeatures: [],
            isHighVolume: true,
            optionalFeatures: [
                {
                    id: 19,
                    name: 'Reviews',
                    cost: 50,
                    description: 'Connect your Google and Facebook business profiles to earn, reply to, and track online reviews.'
                },
                /*
                {
                    id: 16,
                    name: 'Call Forwarding',
                    nameHint: ' (up to 25 dashboards)',
                    cost: 25,
                    description: 'Callers are seamlessly forwarded to a voice-enabled phone number you provide. Priced per account, up to 25 dashboards.'
                },
                */
            ],
            priorPlan: 'Enterprise',
            linkedInConversionId: 9948761
        },
        {
            id: 3005,
            name: 'High Volume Tier 2',
            price: 1460,
            newPrice: 1460,
            includedTexts: '100,000',
            addTexts: '$0.016',
            addTextsNew: '$0.016',
            dashboards: 10,
            link: 'highvolume2',
            includedFeatures: [],
            isHighVolume: true,
            optionalFeatures: [
                {
                    id: 19,
                    name: 'Reviews',
                    cost: 50,
                    description: 'Connect your Google and Facebook business profiles to earn, reply to, and track online reviews.'
                },
                /*
                {
                    id: 16,
                    name: 'Call Forwarding',
                    nameHint: ' (up to 25 dashboards)',
                    cost: 25,
                    description: 'Callers are seamlessly forwarded to a voice-enabled phone number you provide. Priced per account, up to 25 dashboards.'
                },
                */
            ],
            priorPlan: 'Enterprise',
            linkedInConversionId: 9948769
        },
        {
            id: 3006,
            name: 'High Volume Tier 3',
            price: 2900,
            newPrice: 2900,
            includedTexts: '250,000',
            addTexts: '$0.013',
            addTextsNew: '$0.013',
            dashboards: 10,
            link: 'highvolume3',
            includedFeatures: [],
            isHighVolume: true,
            optionalFeatures: [
                {
                    id: 19,
                    name: 'Reviews',
                    cost: 50,
                    description: 'Connect your Google and Facebook business profiles to earn, reply to, and track online reviews.'
                },
                /*
                {
                    id: 16,
                    name: 'Call Forwarding',
                    nameHint: ' (up to 25 dashboards)',
                    cost: 25,
                    description: 'Callers are seamlessly forwarded to a voice-enabled phone number you provide. Priced per account, up to 25 dashboards.'
                },
                */
            ],
            linkedInConversionId: 9948777
        }
    ];
    getPlans() {
        return this.plans;
    }
    getHipaaDescription() {
        return {
            cost: 50,
            featureId: 18
        }
    }
    getPlan(planLink) {
        return this.plans.find((p) => p.link === planLink);
    }

}